import { TablePagination } from "@mui/material";
import { PaginatedData } from "../../../hooks/PaginationHooks";
import { useTranslation } from "react-i18next";

interface Props {
    paginatedData: PaginatedData<any>
}

/**
 * A component which displays pagination buttons based on PaginationParameters which is used by a few backend apis
 * when pagination is done server side
 */
export function ServerSidePagination(props: Props) {
    const { t } = useTranslation();
    const { paginationParameters } = props.paginatedData;
    const itemsPerPage = Math.max(1, paginationParameters.limit ?? 10);
    const currentPage = Math.floor((paginationParameters.offset ?? 0) / itemsPerPage);

    function updatePage(page: number, newItemsPerPage: number) {
        props.paginatedData.handleOnPageChange({
            ...paginationParameters,
            limit: newItemsPerPage,
            offset: newItemsPerPage * page,
        });
    }

    return <TablePagination
        component="div"
        count={props.paginatedData.totalCount}
        page={currentPage}
        onPageChange={(_, v) => updatePage(v, itemsPerPage)}
        rowsPerPage={itemsPerPage}
        onRowsPerPageChange={(c) => updatePage(0, parseInt(c.target.value, 10))}
        labelRowsPerPage={`${t("label.rowsPerPage")}:`}
    />;
}